export default "__VITE_ASSET__d73610dc__"